/**
 * Client helpers for server-rendered pack artifact downloads (PDF / XLSX).
 */

export type RenderFormat = 'pdf' | 'xlsx';

const UNSAFE_FILENAME = /["*/:<>?\\|]+/g;

/**
 * Build a download filename from the dashboard name and format.
 */
export function packDownloadFilename(
  dashboardName: string | undefined,
  format: RenderFormat,
): string {
  const safe = (dashboardName || 'dashboard').replace(UNSAFE_FILENAME, '').trim() || 'dashboard';
  return `${safe}-pack.${format}`;
}

/**
 * Trigger a browser file download from a Blob without navigating away.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}

/**
 * Pick the artifact matching the requested format from a render response.
 */
export function pickRenderedArtifact<T extends { format: string }>(
  artifacts: T[] | undefined,
  format: RenderFormat,
): T | undefined {
  return (artifacts || []).find((item) => item.format === format);
}
